import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import ExpandMore from '@material-ui/icons/ExpandMore';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import style from './style/customSelectWithIdStyle';

class CustomSelectWithId extends Component {
  state = {};

  handleSimple = (event) => {
    this.setState({ simpleSelect: event.target.value });
  };

  handleMultiple = (event) => {
    this.setState({ multipleSelect: event.target.value });
  };

  render() {
    const {
      classes,
      multiple,
      id,
      noIds,
      labelText,
      labelClassName,
      helpText,
      placeholder,
      value,
      data,
      success,
      error,
      handleChange,
      customClass,
      white,
    } = this.props;

    const successClass = cx({
      [classes.feedback]: true,
      [classes.labelRootSuccess]: true,
      [classes.feedbackWithHelp]: helpText !== '',
    });
    const selectClasses = cx({
      [classes.select]: true,
      [classes.white]: white,
      [classes.selectSuccess]: success,
      [classes.selectError]: error,
    });

    return (
      <span className={customClass}>
        <InputLabel htmlFor='select' className={labelClassName}>
          {labelText}
        </InputLabel>
        <InputLabel htmlFor='select' shrink={false} className={classes.selectLabel}>
          {value ? '' : placeholder}
        </InputLabel>
        <Select
          multiple={multiple}
          IconComponent={(props) => <ExpandMore {...props} />}
          value={value}
          fullWidth
          onChange={(event) => handleChange(event, id)}
          MenuProps={{ className: classes.selectMenu }}
          classes={{ select: selectClasses }}
          disableUnderline
          displayEmpty>
          <MenuItem
            disabled
            classes={{
              root: classes.selectMenuItem,
            }}>
            {labelText || 'Sélectionner'}
          </MenuItem>
          {Boolean(data && data.length) &&
            data.map((element, index) => {
              return (
                <MenuItem
                  key={index}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={noIds ? element : element._id}>
                  {noIds ? element : element.name}
                </MenuItem>
              );
            })}
        </Select>
        {success && <Check className={successClass} />}
        {helpText && <FormHelperText>{helpText}</FormHelperText>}
      </span>
    );
  }
}

CustomSelectWithId.propTypes = {
  labelText: PropTypes.string,
  noIds: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  customClass: PropTypes.string,
  white: PropTypes.bool,
  data: PropTypes.array,
  value: PropTypes.string,
  handleChange: PropTypes.func,
};

CustomSelectWithId.defaultProps = {
  customClass: '',
};

export default withStyles(style)(CustomSelectWithId);
